/** Ancres navigation accueil public (header + footer « Parcourir »). */
export const PUBLIC_HOME_NAV_ITEMS = [
  { id: 'apropos', label: 'Le centre', hash: '#apropos' },
  { id: 'filieres', label: 'Formations', hash: '#filieres' },
  { id: 'tarifs', label: 'Tarifs', hash: '#tarifs' },
  { id: 'vacations', label: 'Vacations', hash: '#vacations' },
] as const;

export type PublicHomeNavId = (typeof PUBLIC_HOME_NAV_ITEMS)[number]['id'];
